import React, { FC } from 'react'

type IconProps = {
  size?: number
  className?: string
}

export const BoldPlusIcon: FC<IconProps> = ({ className, size }) => {
  return (
    <svg
      className={className}
      fill={'none'}
      height={size}
      viewBox={'0 0 40 40'}
      width={size}
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <path
        d={'M17.9013 29V22.0427H11V17.9169H17.9013V11H22.139V17.9169H29V22.0427H22.139V29H17.9013Z'}
        fill={'white'}
      />
    </svg>
  )
}
